module.exports = __webpack_public_path__ + "static/img/two.7740c5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/5/two.png
// module id = OdZH
// module chunks = 1